import type { SVGProps } from "react";

type IconProps = SVGProps<SVGSVGElement>;

const IconBase = ({ className, children, ...props }: IconProps) => (
  <svg
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
    className={className}
    {...props}
  >
    {children}
  </svg>
);

export const AlertTriangleIcon = (props: IconProps) => (
  <IconBase {...props}>
    <path d="M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0Z" />
    <path d="M12 9v4" />
    <path d="M12 17h.01" />
  </IconBase>
);

export const ArrowRightIcon = (props: IconProps) => (
  <IconBase {...props}>
    <path d="M5 12h14" />
    <path d="m12 5 7 7-7 7" />
  </IconBase>
);

export const BookOpenIcon = (props: IconProps) => (
  <IconBase {...props}>
    <path d="M12 7v14" />
    <path d="M3 5.8A2.8 2.8 0 0 1 5.8 3H9a3 3 0 0 1 3 3v15a3 3 0 0 0-3-3H5.8A2.8 2.8 0 0 1 3 15.2Z" />
    <path d="M21 5.8A2.8 2.8 0 0 0 18.2 3H15a3 3 0 0 0-3 3v15a3 3 0 0 1 3-3h3.2a2.8 2.8 0 0 0 2.8-2.8Z" />
  </IconBase>
);

export const ListIcon = (props: IconProps) => (
  <IconBase {...props}>
    <path d="M8 6h13" />
    <path d="M8 12h13" />
    <path d="M8 18h13" />
    <path d="M3 6h.01" />
    <path d="M3 12h.01" />
    <path d="M3 18h.01" />
  </IconBase>
);

export const ShieldCheckIcon = (props: IconProps) => (
  <IconBase {...props}>
    <path d="M20 13c0 5-3.5 7.5-8 9-4.5-1.5-8-4-8-9V5l8-3 8 3Z" />
    <path d="m9 12 2 2 4-4" />
  </IconBase>
);

export const ExternalLinkIcon = (props: IconProps) => (
  <IconBase {...props}>
    <path d="M15 3h6v6" />
    <path d="m10 14 11-11" />
    <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
  </IconBase>
);

export const GraduationCapIcon = (props: IconProps) => (
  <IconBase {...props}>
    <path d="M22 10 12 5 2 10l10 5 10-5Z" />
    <path d="M6 12v5c3.5 2 8.5 2 12 0v-5" />
    <path d="M22 10v6" />
  </IconBase>
);

export const HelpCircleIcon = (props: IconProps) => (
  <IconBase {...props}>
    <circle cx="12" cy="12" r="10" />
    <path d="M9.1 9a3 3 0 1 1 5.8 1c-.4.8-1.2 1.3-2 1.9-.7.5-.9.9-.9 2.1" />
    <path d="M12 17h.01" />
  </IconBase>
);

export const LockIcon = (props: IconProps) => (
  <IconBase {...props}>
    <rect x="4" y="11" width="16" height="10" rx="2" />
    <path d="M8 11V7a4 4 0 0 1 8 0v4" />
  </IconBase>
);

export const UploadIcon = (props: IconProps) => (
  <IconBase {...props}>
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
    <path d="m17 8-5-5-5 5" />
    <path d="M12 3v12" />
  </IconBase>
);

export const MagicWandIcon = (props: IconProps) => (
  <IconBase {...props}>
    <path d="m15 4 5 5" />
    <path d="m14 5 5 5-9 9-5-5Z" />
    <path d="M5 2v3" />
    <path d="M3.5 3.5h3" />
    <path d="M19 16v3" />
    <path d="M17.5 17.5h3" />
  </IconBase>
);

export const UserPlusIcon = (props: IconProps) => (
  <IconBase {...props}>
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M19 8v6" />
    <path d="M22 11h-6" />
  </IconBase>
);
